import React, { ReactNode, Suspense } from "react";

//
// Wrapper léger autour de React.Suspense.
//
// NOTE historique : une ancienne implémentation (cf. SSRS22-474) retardait
// le rendu des children via `setMounted(true)` dans un useEffect pour éviter
// un flicker au chargement. Ce pattern provoquait des erreurs d'hydration
// React (#418 / #421 / #422) car un state update arrivait pendant
// l'hydration d'un Suspense boundary, forçant React à jeter le HTML SSR et
// re-rendre tout le sous-arbre côté client ("blink" visuel sur toutes les
// pages).
//
// On est revenus à un Suspense standard : le fallback reste rendu côté SSR
// et pendant le chargement du chunk React.lazy, les vrais enfants prennent
// la relève après hydration sans re-render parasite.
//

type Props = {
  fallback?: ReactNode;
  children: ReactNode;
};

export const SuspenseHelper: React.FC<Props> = ({
  fallback = <></>,
  children,
}) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};
